import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/account-usage')({
  beforeLoad: () => getTitleContextSlice('Account Usage'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
